

















































































import AirlineCompany from "@/store/entities/flight/airlineCompany";
import { Component, Vue } from "vue-property-decorator";
import AddCompany from "./modals/addCompany.vue";

@Component({
  components: { AddCompany },
})
export default class Companies extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  airlineCompanies: AirlineCompany[] = [];

  created() {
    this.getAirlineCompanies();

    (this.headers = [
      { text: "Havayolu İsmi", value: "name" },
      { text: "İşlemler", value: "transactions" },
    ]),
      (this.mockData = [
        {
          name: "REDWINGS",
        },
      ]);

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Tanımlamalar", disabled: true },
      { text: "Havayolu Şirketleri", disabled: true },
    ];
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getAirlineCompanies() {
    await this.$store.dispatch({
      type: "airlineCompany/getAirlineCompanies",
    });

    this.airlineCompanies = this.$store.state.airlineCompany.list;
  }

  editAirlineCompany(item) {
    this.$store.state.airlineCompany.editAirlineCompany = item;
    this.isOpenModal = true;
  }

  openModal() {
    this.$store.state.airlineCompany.editAirlineCompany = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getAirlineCompanies();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
